import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import { Row, Col, Button } from 'reactstrap'
import FalconModal from '../../components/Inputs/FalconModal'
import { getReservationBenefitCardSchema, getReservationBenefitCardUISchema, getReservationBenefitTimeCardSchema, getReservationBenefitTimeCardUISchema } from '../../components/Inputs/dataschemas'
// import ReactTable from 'react-table'
import ReactTable from '../../components/Lists/ReactTableWrapper'
import { filterCaseInsensitive, getTdProps } from '../../components/FalconTable'
import FalconLoading from '../../components/Inputs/FalconLoading'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'
import Infobox from '../../components/Infos/Infobox'
import { DEFAULT_SPORTS } from '../../sports'
import { Typography } from '@mui/material'

class ReservationBenefitCardsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: true, cardModalOpen: false,  timeCardModalOpen: false, cards: null }
  }

  componentDidMount() {
    this.updateData()
  }

  updateData = () => {
    Promise.all([
      // getSports returns a DocumentReference, so it needs .get() - without it
      // sportdoc.exists is undefined and the customer's own sports never merge in.
      this.props.firebase.getSports().get(),
      this.props.firebase.getBenefitCards(),
      this.props.firebase.getResourses(),
      this.props.firebase.getReservationBenefitCardTimings(),
      this.props.firebase.getImages()]).then((values) => {
        const cards = []
        const resources = []
        const timings = []
        const sports = [...DEFAULT_SPORTS]
        const [sportdoc, benefitcarddocs, resoursedocs, timingdocs, images] = values
        // eslint-disable-next-line
        if (sportdoc.exists) {
          sports.push(...sportdoc.data().list)
        }
        // unique array of sports
        const uniqueSports = [...new Map(sports.map((item) => [item['key'], item])).values()]
        uniqueSports.sort((a, b) => a.label.localeCompare(b.label))

        // resources
        if (!resoursedocs.empty) {
          const _d = resoursedocs.docs
            .map((sh) => {
              return { ...sh.data(), id: sh.id }
            })
          resources.push(..._d)
        }

          if (!timingdocs.empty) {
            const _d = timingdocs.docs
              .map((sh) => {
                return { ...sh.data(), id: sh.id }
              })
            timings.push(..._d)
          }
          
        // benefit cards
        if (!benefitcarddocs.empty) {
          const _d = benefitcarddocs.docs
            .map((sh) => {
              return { ...sh.data(), id: sh.id }
            }).filter((sh) => sh.collection === 'reservations')
          console.log('benefit cards', _d)
          this.setState(
            {
              raw: _d,
              sports: uniqueSports,
              resources,
              timings,
              images
            },
            this.filterData
          )
        } else {
        this.setState({ raw: cards, sports, resources, timings, images }, this.filterData)
      }
    })
  }

  handleRowSelect = (e) => {
    const _result = this.state.cards.filter((r) => r.id === e)
    this.setState({ selectedResource: _result[0] }, this.toggleCardModal)
  }

  handleTimeRowSelect = (e) => {
    const _result = this.state.cards.filter((r) => r.id === e)
    this.setState({ selectedResource: _result[0] }, this.toggleTimeCardModal)
  }

  filterData = async () => {
    const data = []
    for (let i = 0; i < this.state.raw.length; i++) {
      let price = this.state.raw[i].price ? this.state.raw[i].price / 100 : 0
      if (this.state.raw[i].variations && this.state.raw[i].variations.length > 0) {
        price = this.state.raw[i].variations[0].price ? this.state.raw[i].variations[0].price : 0
      }
      data.push({
        ...this.state.raw[i],
        price,
        actions: this.getActions(this.state.raw[i]),
      })
    }
    this.setState({ loading: false, cards: data })
  }

  deleteCard = async (id) => {
    await this.props.firebase.deleteBenefitCard(id)
    this.setState({ loading: true }, this.updateData)
  }

  getActions = (row) => {
    return (
      <>
        <div className='actions-right'>
          {}
          <Button
            color='danger'
            size='sm'
            onClick={(el) => {
              this.deleteCard(row.id)
            }}
          >
            <span className='btn-label'>
              <i className='nc-icon nc-simple-remove' />
            </span>
          </Button>
        </div>
      </>
    )
  }

  addNewCard = () => {
    this.setState({ selectedResource: {} }, this.toggleCardModal)
  }

  addNewTimeCard = () => {
    this.setState({ selectedResource: {} }, this.toggleTimeCardModal)
  }

  toggleTimeCardModal = () => {
    this.setState({
      timeCardModalOpen: !this.state.timeCardModalOpen,
    })
  }

  toggleCardModal = () => {
    this.setState({
      cardModalOpen: !this.state.cardModalOpen,
    })
  }

  getEnhancedCardSchema = () => {
    const schema = getReservationBenefitCardSchema()
    const items = { oneOf: [] }
    // eslint-disable-next-line array-callback-return
    this.state.resources
      .sort((a, b) => a.displayName.localeCompare(b.displayName))
      .forEach((res) => {
        items.oneOf.push({ const: res.id, title: res.displayName })
      })
    schema.properties.resources.items = items
    this.state.timings.forEach((timing) => {
      schema.properties.schedule.oneOf.push({ const: timing.id, title: timing.name })
    })
    if (this.state.images) {
      schema.dependencies.availableinshop.oneOf[0].properties.image.items.images = this.state.images
    }
    return schema
  }

  getEnhancedTimeCardSchema = () => {
    const schema = getReservationBenefitTimeCardSchema()
    const items = { oneOf: [] }
    // eslint-disable-next-line array-callback-return
    this.state.resources
      .sort((a, b) => a.displayName.localeCompare(b.displayName))
      .forEach((res) => {
        items.oneOf.push({ const: res.id, title: res.displayName })
      })
    schema.properties.resources.items = items
    this.state.timings.forEach((timing) => {
      schema.properties.schedule.oneOf.push({ const: timing.id, title: timing.name })
    })
    if (this.state.images) {
      schema.dependencies.availableinshop.oneOf[0].properties.image.items.images = this.state.images
    }
    return schema
  }


  createCardModal = () => {
    return (
      <FalconModal
        onUpdate={this.props.firebase.updateReservationBenefitCard}
        onCreate={this.props.firebase.createReservationBenefitCard}
        modifiedCallback={this.updateData}
        toggle={this.toggleCardModal}
        resource={this.state.selectedResource}
        isOpen={this.state.cardModalOpen}
        uiSchema={getReservationBenefitCardUISchema()}
        dataSchema={this.getEnhancedCardSchema()}
        title={
          this.state.selectedResource && this.state.selectedResource.id ? 'Muokkaa sarjakorttia' : 'Uusi sarjakortti'
        }
        size='lg'
      />
    )
  }

  createTimeCardModal = () => {
    return (
      <FalconModal
        onUpdate={this.props.firebase.updateReservationBenefitTimeCard}
        onCreate={this.props.firebase.createReservationBenefitTimeCard}
        modifiedCallback={this.updateData}
        toggle={this.toggleTimeCardModal}
        resource={this.state.selectedResource}
        isOpen={this.state.timeCardModalOpen}
        uiSchema={getReservationBenefitTimeCardUISchema()}
        dataSchema={this.getEnhancedTimeCardSchema()}
        title={
          this.state.selectedResource && this.state.selectedResource.id ? 'Muokkaa varausaikakorttia' : 'Uusi varausaikakortti'
        }
        size='lg'
      />
    )
  }

  render() {
    if (this.state.loading) {
      return <FalconLoading />
    } else {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>
                <Button onClick={this.addNewCard}>Lisää varaussarjakortti</Button>{' '}
                <Button onClick={this.addNewTimeCard}>Lisää varausaikakortti</Button>
              </Col>
              <Col>
                <Infobox index={'0'}/>
                {/* <Alert severity='info'>
                  <strong>Info!</strong> Sarjakortit ovat aktiviteetteihin/tapahtumiin liittyviä kortteja.
                </Alert> */}
              </Col>
            </Row>
            <Row>
              <Col md='12'>
                <ReactTable
                  data={this.state.cards.filter((r) => r.type === 'count')}
                  filterable
                  noDataText='Ei löytynyt yhtään sarjakorttia'
                  defaultFilterMethod={(filter, row) => filterCaseInsensitive(filter, row)}
                  columns={[
                    {
                      Header: 'Sarjakortin nimi',
                      accessor: 'name',
                    },
                    {
                      Header: 'Kuvaus',
                      accessor: 'description',
                    },
                    {
                      Header: 'Määrä',
                      accessor: 'count',
                    },
                    {
                      Header: 'Kesto',
                      accessor: 'reservationduration',
                      renderCell: (params) => {
                        return <span>{params.value} min</span>
                      }
                    },
                    {
                      Header: 'Hinta',
                      accessor: 'price',
                      renderCell: (params) => {
                        return <span>{params.value} €</span>
                      }
                    },
                    {
                      Header: 'Muokkaa',
                      accessor: 'edit',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        if(params.row.type === 'count') {
                        return (
                          <EditButton
                            onClick={(el) => {
                              this.handleRowSelect(params.row.id)
                            }}
                          />
                          )
                        } else {
                          return (
                            <EditButton
                              onClick={(el) => {
                                this.handleTimeRowSelect(params.row.id)
                              }
                            }
                            />
                          )
                        }
                      },
                    },
                    {
                      Header: 'Poista',
                      accessor: 'actions',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        return (
                          <DeleteButton
                            onClick={(el) => {
                              this.deleteCard(params.row.id)
                            }}
                          />
                        )
                      },
                    },
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  getTdProps={(state, rowInfo, col) => getTdProps(rowInfo, col, this.handleRowSelect)}
                  className='-striped -highlight primary-pagination'
                  noSumRow={true}
                  height={'40vh'}
                />
              </Col>
            </Row>
            <Row>
              <Col md='12' className='mt-3'>
                <ReactTable
                  data={this.state.cards.filter((r) => r.type === 'time')}
                  filterable
                  noDataText='Ei löytynyt yhtään aikakorttia'
                  defaultFilterMethod={(filter, row) => filterCaseInsensitive(filter, row)}
                  columns={[
                    {
                      Header: 'Varausaikakortin nimi',
                      accessor: 'name',
                    },
                    {
                      Header: 'Kuvaus',
                      accessor: 'description',
                      renderCell: (params) => {
                        return <div style={{ marginTop: 10 }} dangerouslySetInnerHTML={{ __html: params.value }}></div>
                      }
                    },
                    {
                      Header: 'Minuuttimäärä',
                      accessor: 'time',
                    },
                    {
                      Header: 'Hinta',
                      accessor: 'price',
                      renderCell: (params) => {
                        return <span>{params.value} €</span>
                      }
                    },
                    {
                      Header: 'Muokkaa',
                      accessor: 'edit',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        if(params.row.type === 'count') {
                        return (
                          <EditButton
                            onClick={(el) => {
                              this.handleRowSelect(params.row.id)
                            }}
                          />
                          )
                        } else {
                          return (
                            <EditButton
                              onClick={(el) => {
                                this.handleTimeRowSelect(params.row.id)
                              }
                            }
                            />
                          )
                        }
                      },
                    },
                    {
                      Header: 'Poista',
                      accessor: 'actions',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        return (
                          <DeleteButton
                            onClick={(el) => {
                              this.deleteCard(params.row.id)
                            }}
                          />
                        )
                      },
                    },
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  getTdProps={(state, rowInfo, col) => getTdProps(rowInfo, col, this.handleRowSelect)}
                  className='-striped -highlight primary-pagination'
                  noSumRow={true}
                  height={'40vh'}
                />
              </Col>
            </Row>
            {this.state.alert}
            {this.createCardModal()}
            {this.createTimeCardModal()}
          </div>
        </>
      )
    }
  }
}

export default withFirebase(ReservationBenefitCardsContainer)
